import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as filesDemo from '../files-demo'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: filesDemo.RESOURCE.payload.dimension.partialId,
      partialId: filesDemo.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Human-readable label for this sandbox record',
    isOptional: true,
    name: 'Label',
    partialId: PartialId.Standard.create('label'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
